/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Priority/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Priority({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/Priority"
  
}) {
let cardPriorityValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'priority',
})
let constantData = 'medium'
let aggregateData = fromAggregate.equals(cardPriorityValueData, constantData)
let cardPriorityValueData1 = fromData.useDataValue({ viewPath,
context: 'card',
path: 'priority',
})
let constantData1 = 'high'
let aggregateData1 = fromAggregate.equals(cardPriorityValueData1, constantData1)
let cardPriorityValueData2 = fromData.useDataValue({ viewPath,
context: 'card',
path: 'priority',
})
let constantData2 = 'urgent'
let aggregateData2 = fromAggregate.equals(cardPriorityValueData2, constantData2)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let dtColorsYellow200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.200'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let cardPriorityValueData3 = fromData.useDataValue({ viewPath,
context: 'card',
path: 'priority',
})
let constantData3 = 'medium'
let aggregateData3 = fromAggregate.equals(cardPriorityValueData3, constantData3)
let cardPriorityValueData4 = fromData.useDataValue({ viewPath,
context: 'card',
path: 'priority',
})
let constantData4 = 'high'
let aggregateData4 = fromAggregate.equals(cardPriorityValueData4, constantData4)
let cardPriorityValueData5 = fromData.useDataValue({ viewPath,
context: 'card',
path: 'priority',
})
let constantData5 = 'urgent'
let aggregateData5 = fromAggregate.equals(cardPriorityValueData5, constantData5)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsYellow900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Priority.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pb-2-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-3-Z1iuO0B': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-4-Z1iuO0B': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-5-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-6-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-7-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-8-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-9-Z1iuO0B': aggregateData ? dtColorsBlue200 : aggregateData1 ? dtColorsYellow200 : aggregateData2 ? dtColorsRed200 : dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={aggregateData3 ? dtColorsBlue900 : aggregateData4 ? dtColorsYellow900 : aggregateData5 ? dtColorsRed900 : dtColorsNeutral900}
 size="tiny"
 weight="medium"
 text={aggregateData3 ? "Medium" : aggregateData4 ? "High" : aggregateData5 ? "Urgent" : "Low"}
 data={aggregateData3 ? "card.priority" : aggregateData4 ? "card.priority" : "card.priority"}
 data={aggregateData3 ? "card.priority" : aggregateData4 ? "card.priority" : "'medium'"}
 aggregate={aggregateData4 ? "/Data/aggregate.js equals" : aggregateData5 ? "/Data/aggregate.js equals" : "/Data/aggregate.js equals"}
/>
</div>
{children}
</React.Fragment>)
}